export default "__VITE_ASSET__CymNRHMh__"